import validate from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "C:/Users/Viktor/Development/asufin-panel-v2/middleware/auth.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {}